import React from "react";
import { Typography, Paper } from "@material-ui/core";
import "./PageErreur.scss";

const Page403 = () => (
  <Paper>
    <Typography align="center" component="p" variant="h4">
      Désolé, mais vous n&apos;avez pas les droits d&apos;accéder à cette page.
    </Typography>
  </Paper>
);

export default Page403;
